module.exports = __webpack_public_path__ + "static/media/demo1.80ec7e54.jpg";